import { Model } from '@shared/models/model';
import { Expose, Type } from 'class-transformer';
import { TruckType } from '../../fleets/models/truck-type.model';
import { ProductType } from '../../shipments/models/product-type.model';
import { ContractActionItem } from '@shared-features/enums';

export class TradeLaneTruckType extends Model {
  @Expose() id: number;
  @Type(() => TruckType)
  @Expose()
  truckType: TruckType = new TruckType();
  @Expose() price: number;
  @Expose() cost: number;
  @Type(() => ProductType)
  @Expose()
  productTypeId?: ProductType = new ProductType();
  /**
   * this for UI
   * it's used for collecting action types that should be sent to BE
   * in case of add/update/delete
   */
  @Expose() actionItem?: ContractActionItem;
}
